// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".double-opt-in__container{position:fixed;display:flex;flex-direction:column;align-items:center;justify-content:center;height:100%;z-index:1000;top:0;inset-inline-start:0;background:#fcfcfc;width:100%}", ""]);
// Exports
module.exports = exports;
